export default "__VITE_ASSET__DT80oD7H__"